<template>
  <div class="placeholder-container">
    <div
      v-for="i in rows"
      class="placeholder"
      v-bind:key="i"
      v-bind:style="{
        width: randomWidth() + '%',
        height: height + 'px',
        marginBottom: i == rows ? bottom + 'px' : margin + 'px',
      }"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    rows: {
      type: Number,
      default: 5,
    },
    margin: {
      type: Number,
      default: 20,
    },
    bottom: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 20,
    },
  },
  methods: {
    randomWidth: function () {
      return Math.random() * (100 - 80) + 80
    },
  },
}
</script>
